export default __webpack_public_path__ + "static/media/Lola.ed38716d.png";